import React, { useState } from 'react';
import './Chatbot.css';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { text: "Hello! I'm Bunty's assistant. How can I help you today?", sender: 'bot' }
  ]);
  const [input, setInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [currentTypingMessage, setCurrentTypingMessage] = useState('');

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const handleSend = () => {
    if (input.trim()) {
      setMessages([...messages, { text: input, sender: 'user' }]);
      setInput('');
      setIsTyping(true);

      // Simple bot responses
      setTimeout(() => {
        const responses = [
          "That's interesting! Tell me more about your project ideas.",
          "I'd love to collaborate! What skills are you looking for?",
          "Check out my projects section for some cool work I've done.",
          "Feel free to reach out through the contact form!",
          "I'm always excited to work on new technologies and challenges."
        ];
        const randomResponse = responses[Math.floor(Math.random() * responses.length)];
        typeMessage(randomResponse);
      }, 1000);
    }
  };

  const typeMessage = (fullMessage) => {
    setCurrentTypingMessage('');
    let index = 0;
    const timer = setInterval(() => {
      if (index < fullMessage.length) {
        setCurrentTypingMessage(prev => prev + fullMessage[index]);
        index++;
      } else {
        clearInterval(timer);
        setIsTyping(false);
        setMessages(prev => [...prev, { text: fullMessage, sender: 'bot' }]);
        setCurrentTypingMessage('');
      }
    }, 50);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSend();
    }
  };

  return (
    <div className="chatbot-container">
      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            <span>Chat with Bunty</span>
            <button onClick={toggleChat} className="close-btn">&times;</button>
          </div>
          <div className="chatbot-messages">
            {messages.map((msg, index) => (
              <div key={index} className={`message ${msg.sender}`}>
                {msg.text}
              </div>
            ))}
            {isTyping && (
              <div className="message bot typing">
                {currentTypingMessage}
                <span className="cursor">|</span>
              </div>
            )}
          </div>
          <div className="chatbot-input">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Type a message..."
            />
            <button onClick={handleSend}>Send</button>
          </div>
        </div>
      )}
      {!isOpen && (
        <button onClick={toggleChat} className="chatbot-toggle">
          💬
        </button>
      )}
    </div>
  );
};

export default Chatbot;
